import { useI18n } from "vue-i18n";

interface TranslationHelper {
    changeCode(code: number): string;
}

export function returnCode(): TranslationHelper {
    const { t } = useI18n();

    return {
        changeCode: (code: number): string => t(`return_code.${code.toString()}`) as string, // 반환 유형을 string으로 지정
    };
}
